// Generated by ReScript, PLEASE EDIT WITH CARE

import Moment from "moment";
import * as Moment$LiveRoom from "../bindings/Moment.bs.js";

function languageToAnalytics(language) {
  if (language === "En") {
    return "English";
  } else if (language === "Fr") {
    return "French";
  } else if (language === "Is") {
    return "Icelandic";
  } else if (language === "It") {
    return "Italian";
  } else if (language === "ZhHans") {
    return "SimplifiedChinese";
  } else if (language === "ZhHant") {
    return "TraditionalChinese";
  } else {
    return "German";
  }
}

function isDateAfterNow(date) {
  return Moment().isAfter(Moment$LiveRoom.moment(undefined, date));
}

export {
  languageToAnalytics ,
  isDateAfterNow ,
}
/* moment Not a pure module */
